import React from "react";
import { Collapse, ConfigProvider, Image, Row, Skeleton } from "antd";
import {
  colorArrowCollapsedCourse,
  textDescHelpTopics,
  backgroundHeaderContentHelpTopics,
  headerBgListItemHelpTopics,
  contentBgListItemHelpTopics,
  textTitleItemHelpTopics,
  colorTextTitle,
  linkEmailText,
  backgroundLinkElement,
} from "../../../../../../config/constant/color";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import Banner from "../../../../../../assets/images/png/help/img_banner_help.png";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import ic_email_helpcenter from "../../../../../../assets/images/svgs/ic_email_helptopics.svg";
import {
  contactEmail,
  subjectEmail,
  bodyEmail,
} from "../../../../../../config/constant/customer_support/index";
import { getAppName } from "../../../../../../utils";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
// for translate
import { useTranslation } from "react-i18next";
const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
    const emailSendMessage = useSelector((state) => state.helpCenter.emailSendMessage);

  const location = useLocation();
  const data = location.state?.data;

  const screens = useBreakpoint();
  const isMobileVersion = screens.xs;
  const isScallingVersion =
  window.innerWidth < 992 && (window.innerHeight >= window.innerWidth || window.innerWidth > window.innerHeight);

  const listCollapseStyling =
    isMobileVersion || isScallingVersion
      ? {
          fontWeight: "500",
          fontSize: "12px",
          lineHeight: "15px",
        }
      : {
          fontWeight: "500",
        };

  const items = [
    {
      key: "1",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="0">
          General
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            digima ASIA (“digima”, “we”, “us”) respect your privacy and want you
            to understand how we collect, use, and share your data. This Privacy
            Policy covers our data collection practices and describes your
            rights to access, correct, or restrict our use of your personal
            data.
          </div>
          <div style={{ marginTop: "15px" }}>
            Unless we link to a different policy or state otherwise, this
            Privacy Policy applies when you visit or use the digima website,
            applications, digital learning platforms, systems or related
            services (the “Services”).
          </div>
          <div style={{ marginTop: "15px" }}>
            <b>
              By using the Services, you agree to the terms of this Privacy
              Policy. You shouldn’t use the Services if you don’t agree with
              this Privacy Policy or any other agreement that governs your use
              of the Services.
            </b>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="1">
          What Data We Get
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          We collect certain data from you directly, like information you enter
          yourself, data about your participation in journey, courses, modules,
          games dan any other activities, including data from third-party
          platforms you connect with digima. We also collect some data
          automatically, like information about your device and what parts of
          our Services you interact with or spend time using.
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="2">
          Data You Provide to Us
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            We may collect different data from or about you depend on how you
            use the Services. Below are some examples to help you better
            understand the data we collect.
          </div>
          <div style={{ marginTop: "10px" }}>
            When you create an account, get registered into the Services and use
            the Services, including through a third-party platform, we collect
            any data you provide directly, including:
          </div>
          <ol style={{ padding: 0, marginLeft: "16px", marginTop: "10px" }}>
            <li
              style={{
                fontWeight: "700",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
              }}
            >
              <div>Account Data</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                In order to use certain features (like enrolling in a journey or
                leaderboard), you need to create a user account. When you create
                or update your account, we collect and store the data you
                provide, like your employee number, email address, password,
                gender, and date of birth, and assign you a unique identifying
                number.
              </div>
            </li>
            <li
              style={{
                fontWeight: "700",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                marginTop: "10px",
              }}
            >
              <div>Profile Data</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                You can also choose to provide profile information like a photo,
                description, link, social media profiles, or other data. Your
                Profile Data might be viewable by others.
              </div>
            </li>
            <li
              style={{
                fontWeight: "700",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                marginTop: "10px",
              }}
            >
              <div>Shared Content</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                Parts of the Services let you interact with other users or share
                content accordingly, including by posting reviews on a module,
                asking or answering questions, sending messages to others, or
                posting photos or other work you upload. Such shared content may
                be viewable by others depending on where it is posted.
              </div>
            </li>
            <li
              style={{
                fontWeight: "700",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                marginTop: "10px",
              }}
            >
              <div>Learning Data</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                When you enroll in, get enrolled and take journey/course/module,
                we collect certain data including which journeys, courses,
                modules, assignments and quizzes you’ve started and completed;
                your exchanges with others; and essays, answers to questions,
                and other items submitted to satisfy learning requirements.
              </div>
            </li>
            <li
              style={{
                fontWeight: "700",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                marginTop: "10px",
              }}
            >
              <div>Payment Data</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                If you make purchases, we collect certain data about your
                purchase (such as your name and zip code) as necessary to
                process your order. You must provide certain payment and billing
                data directly to our payment processing partners, including your
                name, credit card information, billing address, and zip code.
                For security, digima does not collect or store sensitive
                cardholder data, such as full credit card numbers or card
                authentication data.
              </div>
            </li>
            <li
              style={{
                fontWeight: "700",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                marginTop: "10px",
              }}
            >
              <div>Data About Your Accounts on Other Services</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                We may obtain certain information through your social media or
                other online accounts if they are connected to your digima
                account. If you login to digima via another third-party platform
                or service, we ask for your permission to access certain
                information about that other account. For example, depending on
                the platform or service we may collect your name, profile
                picture, account ID number, login email address, location,
                physical location of your access devices, gender, birthday, and
                list of friends or contacts.
              </div>
            </li>
          </ol>

          <div style={{ marginTop: "10px" }}>
            Those platforms and services make information available to us
            through their APIs. The information we receive depends on what
            information you (via your privacy settings) or the platform or
            service decide to give us.
          </div>
          <div style={{ marginTop: "10px" }}>
            If you access or use our Services through a third-party platform or
            service, or click on any third-party links, the collection, use, and
            sharing of your data will also be subject to the privacy policies
            and other agreements of that third party.
          </div>
        </div>
      ),
    },
    {
      key: "4",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="3">
          Data We Collect through Automated Means
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            When you access the Services, we collect certain data by automated
            means, including:
          </div>

          <ol style={{ padding: 0, marginLeft: "16px", marginTop: "10px" }}>
            <li
              style={{
                fontWeight: "700",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                marginTop: "10px",
              }}
            >
              <div>System Data</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                Technical data about your computer or device, like your IP
                address, device type, operating system type and version, unique
                device identifiers, browser, browser language, domain and other
                systems data, and platform types.
              </div>
            </li>
            <li
              style={{
                fontWeight: "700",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                marginTop: "10px",
              }}
            >
              <div>Usage Data</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                Usage statistics about your interactions with the Services,
                including journeys, courses, modules accessed, time spent on the
                Service, pages or screens visited, features used, your search
                queries, click data, date and time, and other data regarding
                your use of the Services.
              </div>
            </li>
            <li
              style={{
                fontWeight: "700",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                marginTop: "10px",
              }}
            >
              <div>Approximate Geographic Data</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                An approximate geographic location, including information like
                country, city, and geographic coordinates, calculated based on
                your IP address and related geotagging abilities.
              </div>
            </li>
          </ol>

          <div style={{ marginTop: "10px" }}>
            The data listed above is collected using server log files and
            tracking technologies, as detailed in the “Cookies and Data
            Collection Tools” section below. It is stored by us and associated
            with your account.
          </div>
        </div>
      ),
    },
    {
      key: "5",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="4">
          How We Get Data About You
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            We use tools like cookies, analytics services, and advertising
            providers to gather the data listed above. If you get enrolled from
            third-party services, then we get the data from the related
            third-party services. Some of these tools and services offer you the
            ability to opt out of data collection.
          </div>

          <div style={{ marginTop: "10px" }}>
            In situations where we obtain your data from a source other than
            you, we process your data on the basis of legitimate interests,
            until you ask us to stop processing your data on the basis of our
            legitimate interests. We will retain your learning records relating
            to degrees, certificates, achievements, leaderboards for our own
            compliance and verification purposes (including where we are
            required to do so by our clients and partners), even after you
            withdraw your consent to our processing of your data. We will
            archive information about your use of the Services. This information
            will only be used in very limited circumstances, such as for
            statistical analysis or a third-party and retention for audit
            purposes relating to commercial contracts.
          </div>
        </div>
      ),
    },
    {
      key: "6",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="5">
          Cookies and Data Collection Tools
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            digima and other service providers acting on our behalf (like Google
            Analytics and other third-parties) use server log files and
            automated data collection tools like cookies, tags, scripts,
            customized links, and learning tracker when you access and use the
            Services. These tools automatically track and collect certain System
            Data and Usage Data (as detailed in Section 1) when you use the
            Services. In some cases, we process data gathered through those Data
            Collection Tools to other data that we collect as described in this
            Privacy Policy.
          </div>

          <div style={{ marginTop: "10px" }}>
            digima uses the following types of cookies:
          </div>
          <ol style={{ padding: 0, marginLeft: "16px" }}>
            <li
              style={{
                fontWeight: "700",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
              }}
            >
              <div>Preferences</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                Cookies that remember data about your application, browser and
                preferred settings that affect the appearance and behavior of
                the Services (like your preferred language).
              </div>
            </li>
            <li
              style={{
                fontWeight: "700",
                marginTop: "10px",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
              }}
            >
              <div>Security</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                Cookies used to enable you to log in and access the Services;
                protect against fraudulent logins; and help detect and prevent
                abuse or unauthorized use of your account.
              </div>
            </li>
            <li
              style={{
                fontWeight: "700",
                marginTop: "10px",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
              }}
            >
              <div>Functional</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                Cookies that store functional settings (like the volume level
                you set for video playback).
              </div>
            </li>
            <li
              style={{
                fontWeight: "700",
                marginTop: "10px",
                fontSize:
                  isMobileVersion || isScallingVersion ? "12px" : "14px",
                lineHeight: (isMobileVersion || isScallingVersion) && "15px",
              }}
            >
              <div>Session State</div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "12px" : "14px",
                  lineHeight: (isMobileVersion || isScallingVersion) && "15px",
                }}
              >
                Cookies that track your interactions with the Services to
                remember your login details and progress you made at certain
                journey/courses/modules/stages. These are strictly necessary for
                the Services to work properly.
              </div>
            </li>
          </ol>
        </div>
      ),
    },
    {
      key: "7",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="6">
          Analytics
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            We use tools like cookies, analytics services, and advertising
            providers to gather the data listed above. If you get enrolled from
            third-party services, then we get the data from the related
            third-party services. Some of these tools and services offer you the
            ability to opt out of data collection.
          </div>

          <div style={{ marginTop: "10px" }}>
            We may use third-party analytics services like Google Analytics on
            the Services. These services use Data Collection Tools to help us
            analyze your use of the Services, including information like events
            within the Services, usage and performance data, and where the
            application was downloaded from. We use this data to improve the
            Services, better understand how the Services perform on different
            devices, and provide information that may be of interest to you.
          </div>
        </div>
      ),
    },
    {
      key: "8",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="7">
          What We Use Your Data For
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            We use your data to do things like provide our Services, communicate
            with you, troubleshoot issues, secure against fraud and abuse,
            improve and update our Services, analyze how people use our Services
            and as required by law or necessary for safety and integrity.
          </div>

          <div style={{ marginTop: "10px" }}>
            We use the data we collect through your use of the Services to:
          </div>
          <ol style={{ padding: 0, marginLeft: "16px" }}>
            <li style={{ marginTop: "10px" }}>
              Provide and administer the Services, including to display
              customized content and facilitate communication with other users;
            </li>
            <li style={{ marginTop: "10px" }}>
              Process your requests and orders for courses, products, specific
              services, information, or features;
            </li>
            <li style={{ marginTop: "10px" }}>
              <div>Communicate with you about your account by:</div>
              <div style={{ display: "flex" }}>
                <div style={{ marginRight: "5px" }}>-</div>
                <div>Responding to your questions and concerns;</div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ marginRight: "5px" }}>-</div>
                <div>
                  Sending you administrative messages and information, including
                  messages from learning admins, notifications about changes to
                  our Service, and updates to our agreements;
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ marginRight: "5px" }}>-</div>
                <div>
                  Sending you information and messages about your progress in
                  journeys, courses, modules, rewards, new services, new
                  features, promotions, newsletters, and other available
                  services;
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ marginRight: "5px" }}>-</div>
                <div>
                  Sending push notifications to your wireless device to provide
                  updates and other relevant messages;
                </div>
              </div>
            </li>
            <li style={{ marginTop: "10px" }}>
              Manage your account preferences;
            </li>
            <li style={{ marginTop: "10px" }}>
              Facilitate the Services’ technical functioning, including
              troubleshooting and resolving issues, securing the Services, and
              preventing fraud and abuse;
            </li>
            <li style={{ marginTop: "10px" }}>Solicit feedback from users;</li>
            <li style={{ marginTop: "10px" }}>
              Identify unique users across devices;
            </li>
            <li style={{ marginTop: "10px" }}>
              Improve our Services and develop new products, services, and
              features;
            </li>
            <li style={{ marginTop: "10px" }}>
              Analyze trends, traffic and track usage data;
            </li>
            <li style={{ marginTop: "10px" }}>
              As required or permitted by law; or
            </li>
            <li style={{ marginTop: "10px" }}>
              As we, in our sole discretion, otherwise determine to be necessary
              to ensure the safety or integrity of our users, employees, third
              parties, the public, or our Services.
            </li>
          </ol>
        </div>
      ),
    },
    {
      key: "9",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="8">
          Who We Share Your Data With
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            We share certain data about you with learning admins, other
            learners, companies, our business partners, analytics providers,
            your social media providers, companies helping us run promotions,
            surveys and advertising companies who help us promote our Services.
            We may also share your data as needed for security, legal
            compliance, or as part of a corporate restructuring. Lastly, we can
            share data in other ways if it is aggregated or de-identified or if
            we get your consent.
          </div>
        </div>
      ),
    },
    {
      key: "10",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="9">
          Security
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            We use appropriate security based on the type and sensitivity of
            data being stored. As with any internet-enabled system, there is
            always a risk of unauthorized access, so it’s important to protect
            your password and to contact us if you suspect any unauthorized
            access to your account.
          </div>

          <div style={{ marginTop: "10px" }}>
            digima takes appropriate security measures to protect against
            unauthorized access, alteration, disclosure, or destruction of your
            personal data that we collect and store. These measures vary based
            on the type and sensitivity of the data. Unfortunately, however, no
            system can be 100% secured, so we cannot guarantee that
            communications between you and digima, the Services, or any
            information provided to us in connection with the data we collect
            through the Services will be free from unauthorized access by third
            parties. Your password is an important part of our security system,
            and it is your responsibility to protect it. You should not share
            your password with any third party, and if you believe your password
            or account has been compromised, you should change it immediately
            and contact support@digimasia.com with any concerns.
          </div>
        </div>
      ),
    },
    {
      key: "11",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="10">
          Updates & Contact Info
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            When we make a material change to this policy, we’ll notify users
            via email, in-product notice, or another mechanism required by law.
            Changes become effective the day they’re posted. Please contact us
            via email or postal mail with any questions, concerns, or disputes.
          </div>
        </div>
      ),
    },
    {
      key: "12",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="11">
          Modifications to This Privacy Policy
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            From time to time, we may update this Privacy Policy. If we make any
            material change to it, we will notify you via email, through a
            notification posted on the Services, or as required by applicable
            law. We will also include a summary of the key changes. Unless
            stated otherwise, modifications will become effective on the day
            they are posted.
          </div>

          <div style={{ marginTop: "10px" }}>
            As permitted by applicable law, if you continue to use the Services
            after the effective date of any change, then your access and/or use
            will be deemed an acceptance of (and agreement to follow and be
            bound by) the revised Privacy Policy. The revised Privacy Policy
            supersedes all previous Privacy Policies.
          </div>
        </div>
      ),
    },
    {
      key: "13",
      label: (
        <div style={listCollapseStyling} id="list-collapse-help" index="12">
          Questions
        </div>
      ),
      children: (
        <div
          style={{
            color: textDescHelpTopics,
            fontSize: isMobileVersion || isScallingVersion ? "12px" : "14px",
          }}
        >
          <div>
            If you have any questions, concerns, or disputes regarding our
            Privacy Policy, please feel free to contact us at{" "}
            <b>{contactEmail}</b>.
          </div>
        </div>
      ),
    },
  ];

  const emailTo = () => {
    
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: headerBgListItemHelpTopics,
            headerPadding: "20px",
            contentBg: contentBgListItemHelpTopics,
            contentPadding: "0 20px 20px 20px",
          },
        },
        token: {
          fontFamily: "Roboto",
        },
      }}
    >
      <div style={{ position: "relative", height: "100%" }}>
        {!(isMobileVersion || isScallingVersion) && (
          <div
            style={{
              height: "130px",
              borderRadius: "0 0 16px 16px",
            }}
          >
            <div
              style={{
                color: "#FFF",
                textAlign: "center",
                position: "relative",
                borderRadius: "0 0 16px 16px",
                display: "grid",
                gridTemplateColumns: "1fr",
              }}
            >
              <h3
                style={{
                  margin: "0",
                  height: "100%",
                  color: "#000",
                  lineHeight: "160px",
                  textAlign: "center",
                  gridRowStart: 1,
                  gridColumnStart: 1,
                }}
              >
                1
              </h3>
              <img
                alt={`Banner_default`}
                style={{
                  width: "100%",
                  height: "130px",
                  objectFit: "cover",
                  objectPosition: "right",
                  gridRowStart: 1,
                  gridColumnStart: 1,
                  borderRadius: "0 0 16px 16px",
                }}
                src={Banner}
              />
            </div>
          </div>
        )}
        {(isMobileVersion || isScallingVersion) && (
          <div
            style={{
              width: "100%",
              height: 48,
              marginTop: "-14px",
              borderBottomRightRadius: "16px",
              borderBottomLeftRadius: "16px",
              background: backgroundHeaderContentHelpTopics,
            }}
          ></div>
        )}

        <div
          className={
            isMobileVersion || isScallingVersion
              ? "list-collapse-mobile"
              : "list-collapse"
          }
          style={{
            padding:
              isMobileVersion || isScallingVersion
                ? "24px 18px"
                : "0 42px 25px 42px",
            top: isMobileVersion || isScallingVersion ? "0" : "-130px",
            position: "relative",
            marginTop: isMobileVersion || isScallingVersion ? "-57px" : "0",
          }}
        >
          {!(isMobileVersion || isScallingVersion) && (
            <div style={{ height: "95px", padding: "20px 0 20px 11%" }}>
              <div
                text-title="text-title-banner-privacy-policy-help-center"
                style={{
                  color: "#FFFF",
                  fontWeight: "500",
                  fontSize: "22px",
                  marginBottom: "5px",
                }}
              >
                {t("feature.feature_help.main_header.assistance_prompt")}
              </div>
              <div
                text-title="text-subtitle-banner-privacy-policy-help-center"
                style={{ color: "#FFFF", fontWeight: "600", fontSize: "14px" }}
              >
                {t("feature.feature_help.main_header.showing")}{" "}
                <span
                  style={{
                    color: textTitleItemHelpTopics,
                    background: "#FFF",
                    padding: "3px 5px",
                    borderRadius: "2px",
                  }}
                >
                  {t("feature.feature_help.side_dpd.privacy_policy")}
                </span>{" "}
                {t("feature.feature_help.main_header.showing_topic")}
              </div>
            </div>
          )}

          <Collapse
            className="align-items-center collapsed-learning-journey"
            style={{ border: "1px #E5E5E6 solid" }}
            expandIconPosition="end"
            expandIcon={({ isActive }) => (
              <span
                style={{
                  backgroundColor: colorArrowCollapsedCourse,
                  borderRadius: "50%",
                  padding: "6px",
                }}
              >
                {isActive ? <UpOutlined /> : <DownOutlined />}
              </span>
            )}
            bordered={false}
            accordion={true}
            destroyInactivePanel={true}
            items={items}
          />

          {(isMobileVersion || isScallingVersion) && (
            <div
              style={{
                padding: "18px",
                width: "100%",
                borderRadius: "8px",
                backgroundColor: backgroundLinkElement,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    color: colorTextTitle,
                    fontWeight: "500",
                    fontSize: "12px",
                  }}
                >
                  {t("feature.feature_help.side_dpd.contact_more_help")}
                </div>
                <a
                  onClick={(e) => {
                    if(emailSendMessage == undefined || emailSendMessage == ""){
                      e.preventDefault();
                    }
                  }}
                  href={ emailSendMessage == undefined || emailSendMessage == "" ? "#" : emailSendMessage }
                  style={{
                    padding: "0",
                    color: linkEmailText,
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "500",
                    fontSize: "12px",
                  }}
                  id="btn-link-contact-help-center"
                >
                  <span style={{ marginRight: "6px" }}>
                    <Image src={ic_email_helpcenter} preview={false} />
                  </span>
                  {data?.loadingProfile ? <Skeleton.Input /> : contactEmail}
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </ConfigProvider>
  );
};

export default PrivacyPolicy;
